module.exports = __webpack_public_path__ + "img/person-walking.5675c946.svg";